import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';

@Injectable()
export class BreadcrumbsService {
    _parts: IBreadcrumbPart[];

    constructor(private _title: Title) {
        this.reset();
    }

    get parts(): IBreadcrumbPart[] {
        return this._parts;
    }

    start(part: IBreadcrumbPart|string) {
        this.reset();
        return this.add(part);
    }

    add(part: IBreadcrumbPart|string) {
        if (typeof part === 'string') {
            part = {name: part};
        }
        this._parts.push(part);
        this.setTitle(part.name);
        return this;
    }

    reset() {
        this._parts = [];
        this._title.setTitle('KKK');
        return this;
    }

    setTitle(title: string) {
        this._title.setTitle(`${title} - KKK`);
    }
}

export interface IBreadcrumbPart {
    name: string;
    instructions?: any[];
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/breadcrumbs/breadcrumbs.service.ts